module.exports = __webpack_public_path__ + "static/img/picture16.52f06ff1.png";